module.exports = __webpack_public_path__ + "media/images/lb/430-6d7bfc154eb26ca14caac03f3c1a0e02.svg";